import reduceReducers from 'reduce-reducers';

import verifyAccountReducer from './verifyAccount-reducer';
import createAccountReducer from './createAccount-reducer';
import createPatientReducer from './createPatient-reducer';
import patientKinReducer from './patientKin-reducer';

export default reduceReducers(
  verifyAccountReducer,
  createAccountReducer,
  createPatientReducer,
  patientKinReducer,
);
